import ROUTES from "./utils/routes";
import {
  BrowserRouter as Router,
  Switch,
  Route, Redirect
} from "react-router-dom";

import Footer from "./components/layout/Footer";

import Home from "./pages/Home";
import Collection from "./pages/Collection";
import NotFound from "./pages/NotFound";
import Details from "./pages/Details";
import Results from "./pages/Results";

//Redux
import { Provider } from "react-redux";
import store from "./store";

function App() {
  return (
    <Router>
      <Provider store={store}>
        <Switch>
          <Route exact path={process.env.PUBLIC_URL}>
              <Redirect to={ROUTES.HOME} />
          </Route>
          <Route exact path={ROUTES.HOME} component={Home} />
          <Route exact path={ROUTES.COLLECTIONS} component={Collection} />
          <Route exact path={ROUTES.DETAILS} component={Details} />
          <Route exact path={ROUTES.SEARCHRESULTS} component={Results} />
          <Route component={NotFound}/>
        </Switch>
        <Footer />
      </Provider>
    </Router>
  );
}

export default App;
